import template from "./quantity-modal.html";
import "./quantity-modal.less";
import { EVENT_LOGOUT } from "../../../constants";

export class Controller {
	constructor(appState, eventBus, $scope, toastr) {
		this.appState = appState;
		this.eventBus = eventBus;
		this.$scope = $scope;
		this.$toastr = toastr;

		this.quantity = this.resolve.item.Quantity;
	}

	$onInit() {
		this.eventBus.register(EVENT_LOGOUT, () => { this.handleClose(); }, this.$scope);
	}

	validate(quantity) {
		try {
			if(quantity === undefined || quantity === null) {
				this.$toastr.error("Quantity is required, please enter a value.");		
				
				return false;
			} 
			
			if(parseFloat(quantity) < 0) {
				this.$toastr.error("Quantity cannot be negative, please enter a positive value or zero.");

				return false;
			}

			return true;
		}
		catch(err) {
			this.$toastr.error("Invalid value, please correct errors");
				
			return false;
		}
	}

	save() {
		const isValid = this.validate(this.quantity);

		if(isValid) {
			this.modalInstance.close({ quantity: this.quantity });
		}
	}

	handleClose() {
		this.modalInstance.dismiss();
	}
}

export default angular
	.module("vesl.components.quantity-modal", [])
	.component("quantityModal", {
		controller: Controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
